class LegacyUtils {

  static prepareResponseData(data) {
    const source = Array.isArray(data) ? data : [data];
    const result = {
      data:       source.map(item => this.formatBasicType(item)),
      isIterable: Array.isArray(data),
    };

    return result.isIterable ? result.data : result.data[0];
  }

  /**
   * Проверяет и форматирует значения по типу для ответа от сервера.
   * @param {*} value
   * @returns {null|Object|Number|String|Boolean|Array.<*>}
   */
  static formatBasicType(value) {
    /**
     * Форматирует все свойства объекта рекурсивно.
     * @param {Object} valueObject
     * @returns {Object}
     */
    function formatObject(valueObject) {
      const result = {};
      Object.keys(valueObject)
            .forEach(key => {
              result[key] = LegacyUtils.formatBasicType(valueObject[key]);
            });
      return result;
    }

    /**
     * Обходит все елементы массива и форматирует их в зависимости от типа.
     * @param {Array.<*>} valueArray
     * @returns {Array.<*>}
     */
    function formatArray(valueArray) {
      return valueArray.map(item => LegacyUtils.formatBasicType(item));
    }

    if (value === null) {
      return null;
    }

    switch (typeof value) {
      case 'undefined':
        return null;
      case 'function':
      case 'boolean':
      case 'number':
      case 'string':
        return value;
      default:
        if (Array.isArray(value)) {
          return formatArray(value);
        }

        // Общее правило для инициализации дат
        if (
          value.hasOwnProperty('date')
          && value.hasOwnProperty('timezone')
          && value.hasOwnProperty('timezoneType')
        ) {
          if (value) {
            let UTCOffset = null;

            if (value.timezone) {
              if (value.timezone === 'UTC') {
                UTCOffset = '+0';
              } else if (value?.timezoneType === 1) {
                UTCOffset = value.timezone.split(':')[0];
              }
            }

            if (typeof value.date === 'string' && !isNaN(Date.parse(value.date))) {
              if (UTCOffset) {
                // UPDATE 23.11.2025. Чтобы отображать время в таймзоне пользователя,
                // мы не должны присваивать таймзону из ответа сервера
                return new Date(value.date);
              }
              return new Date(value.date);
            }
          }
          return null;
        }
        return formatObject(value);
    }
  }
}

export default LegacyUtils;
